<template>
    <div class="spec-page-container">
        <img src="http://cdn.wxhand.com/amb/images/404.png" alt="">
        <p class="content">很遗憾，您访问的的页面挖不到啦！<br><span class="blue">{{ left }}s</span> 后返回主页，您也可以<router-link class="blue" :to="{path: '/'}" replace>手动跳转</router-link></p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                left: 5,
                timer: null,
            };
        },
        mounted() {
            this.timer = setInterval(() => {
                this.left--;

                if (this.left == 0) {
                    this.$router.replace({path: '/'});
                }
            }, 1000);
        },
        methods: {
            back() {
                clearInterval(this.timer);
                this.$router.go(-1);
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        }
    };
</script>

<style lang="less" scoped>
    .spec-page-container {
        position: absolute;
        top: 220px;
        bottom: 0;
        width: 100%;
        max-width: 1561px;
        min-height: 500px;
        background: url(http://cdn.wxhand.com/amb/images/404_bg.png) bottom center no-repeat;
        background-size: auto 100%;
        text-align: center;
    }

    .content {
        display: block;
        margin-top: 20px;
        line-height: 1.5;
        color: #555;
    }

    img {
        width: 230px;
    }

    .blue {
        color: #20a0ff;
    }
</style>


// WEBPACK FOOTER //
// src/view/common/404.vue